import axios from 'axios';
import { Platform } from 'react-native';
import { stringify } from 'qs';
import './type';
import addInterceptors from './interceptors';
const request = axios.create({
    // rn的fetch需要自己读取cookie来设置
    withCredentials: Platform.select({ default: false, web: true }),
    timeout: 50000,
    paramsSerializer: (params) => {
        if (!params) {
            return '';
        }
        return stringify(params);
    },
});
addInterceptors(request);
export default request;
